import React from "react";

import { TabConfigPage } from "../../_shared/pages/TabConfigPage";
import { useTeamsContext } from "../../_shared/state/TeamsContextProvider";

export const SurveyTabConfigPage: React.FC = () => {
  const { teamsContext } = useTeamsContext();

  if (teamsContext?.meeting?.id) {
    return (
      <TabConfigPage
        applicationType="msteams"
        urlBase="/msteams"
        entityPrefix="surveys_list"
        displayName="Polly"
        title="Ready to lead a more engaging meeting"
        subtitle={`Hit "Save" to add Polly to this meeting as a tab.`}
        footerText="Not sure exactly what Polly can help you accomplish?"
        helpLink="https://www.polly.ai/polly-for-teams-meetings"
      />
    );
  }

  return (
    <TabConfigPage
      applicationType="msteams"
      urlBase="/msteams"
      entityPrefix="surveys_list"
      displayName="Polly"
      title="Add Polly to a tab to manage all your channel pollys in one place"
      footerText="Not sure exactly what pinning a tab does?"
      helpLink="https://www.polly.ai/help/microsoft-teams/pinning-polly-as-a-tab"
    />
  );
};
